// extracted by mini-css-extract-plugin
export var blue = "_1j-g";
export var brand = "_1j-c";
export var darkGrey = "_1j-f";
export var disabled = "_1j-6";
export var disabledSubtle = "_1j-7";
export var error = "_1j-8";
export var green = "_1j-h";
export var grey = "_1j-e";
export var icon = "_1j-0";
export var inherit = "_1j-b";
export var lightGrey = "_1j-d";
export var orange = "_1j-j";
export var pink = "_1j-l";
export var primary = "_1j-1";
export var purple = "_1j-m";
export var quaternary = "_1j-4";
export var quinary = "_1j-5";
export var red = "_1j-k";
export var secondary = "_1j-2";
export var success = "_1j-a";
export var tertiary = "_1j-3";
export var warning = "_1j-9";
export var white = "_1j-n";
export var yellow = "_1j-i";